export class Dashboard {

    private payerCountry: string;
    private currencyCode: string;
    private cpaKey: string;
    private cpaName: string | null;
    private discountKey: string;
    private discountProductGroup: string;
    private marketedProductGroup: string | null;
    private productGroupOrder: number | null;
    private reviewDtm: number | null;
    private reportDtm: number | null;
    private initialDiscountPercent: number | null;
    private discountPercent: number | null;
    private revenueCount: number | null;
    private rampUpPeriod: number | null;
    private initialDiscountPeriod: number | null;
    private measurementPeriod: number | null;
    private discountPeriod: number | null;
    private rampUpStartDate: number | null;
    private rampUpEndDate: number | null;
    private initialDiscountStartDate: number | null;
    private initialDiscountEndDate: number | null;
    private measurementStartDate: number | null;
    private measurementEndDate: number | null;
    private discountStartDate: number | null;
    private discountEndDate: number | null;
    private nextMeasurementPeriod: number | null;
    private nextMeasurementMonths: number | null;
    private nextDiscountPeriod: number | null;
    private nextMeasurementStartDateOffset: number | null;
    private nextMeasurementStartDate: number | null;
    private nextMeasurementEndDate: number | null;
    private nextDiscountStartDate: number | null;
    private nextDiscountEndDate: number | null;
    private thresholdType: string | null;
    private discountTiersAndValues: string | null;
    private shipmentProgressCount: number | null;
    private revenueProgressCount: number | null;
    private shipmentGapToCurrentLevel: number | null;
    private revenueGapToCurrentLevel: number | null;
    private shipmentGapToNextLevel: number | null;
    private revenueGapToNextLevel: number | null;
    private reviewFlag: string | null;
    private activeRampUpPeriodFlag: string | null;
    private activeInitialDiscountPeriodFlag: string | null;

    constructor(raw: any) {
        if (raw) {
            this.setPayerCountry(raw.PAYER_COUNTRY);
            this.setCurrencyCode(raw.CURRENCY_CODE);
            this.setCpaKey(raw.CPA_KEY);
            this.setCpaName(raw.CPA_NAME);
            this.setDiscountKey(raw.DISCOUNT_KEY);
            this.setDiscountProductGroup(raw.DISCOUNT_PRODUCT_GROUP);
            this.setMarketedProductGroup(raw.MARKETED_PRODUCT_GROUP);
            this.setProductGroupOrder(raw.PRODUCT_GROUP_ORDER);
            this.setReviewDtm(raw.REVIEW_DTM);
            this.setReportDtm(raw.REPORT_DTM);
            this.setInitialDiscountPercent(raw.INITIAL_DISCOUNT_PERCENT);
            this.setDiscountPercent(raw.DISCOUNT_PERCENT);
            this.setRevenueCount(raw.REVENUE_COUNT);
            this.setRampUpPeriod(raw.RAMP_UP_PERIOD);
            this.setInitialDiscountPeriod(raw.INITIAL_DISCOUNT_PERIOD);
            this.setMeasurementPeriod(raw.MEASUREMENT_PERIOD);
            this.setDiscountPeriod(raw.DISCOUNT_PERIOD);
            this.setRampUpStartDate(raw.RAMP_UP_START_DATE);
            this.setRampUpEndDate(raw.RAMP_UP_END_DATE);
            this.setInitialDiscountStartDate(raw.INITIAL_DISCOUNT_START_DATE);
            this.setInitialDiscountEndDate(raw.INITIAL_DISCOUNT_END_DATE);
            this.setMeasurementStartDate(raw.MEASUREMENT_START_DATE);
            this.setMeasurementEndDate(raw.MEASUREMENT_END_DATE);
            this.setDiscountStartDate(raw.DISCOUNT_START_DATE);
            this.setDiscountEndDate(raw.DISCOUNT_END_DATE);
            this.setNextMeasurementPeriod(raw.NEXT_MEASUREMENT_PERIOD);
            this.setNextMeasurementMonths(raw.NEXT_MEASUREMENT_MONTHS);
            this.setNextDiscountPeriod(raw.NEXT_DISCOUNT_PERIOD);
            this.setNextMeasurementStartDateOffset(raw.NEXT_MEASUREMENT_START_DATE_OFFSET);
            this.setNextMeasurementStartDate(raw.NEXT_MEASUREMENT_START_DATE);
            this.setNextMeasurementEndDate(raw.NEXT_MEASUREMENT_END_DATE);
            this.setNextDiscountStartDate(raw.NEXT_DISCOUNT_START_DATE);
            this.setNextDiscountEndDate(raw.NEXT_DISCOUNT_END_DATE);
            this.setThresholdType(raw.THRESHOLD_TYPE);
            this.setDiscountTiersAndValues(raw.DISCOUNT_TIERS_AND_VALUES);
            this.setShipmentProgressCount(raw.SHIPMENT_PROGRESS_COUNT);
            this.setRevenueProgressCount(raw.REVENUE_PROGRESS_COUNT);
            this.setShipmentGapToCurrentLevel(raw.SHIPMENT_GAP_TO_CURRENT_LEVEL);
            this.setRevenueGapToCurrentLevel(raw.REVENUE_GAP_TO_CURRENT_LEVEL);
            this.setShipmentGapToNextLevel(raw.SHIPMENT_GAP_TO_NEXT_LEVEL);
            this.setRevenueGapToNextLevel(raw.REVENUE_GAP_TO_NEXT_LEVEL);
            this.setReviewFlag(raw.REVIEW_FLAG);
            this.setActiveRampUpPeriodFlag(raw.ACTIVE_RAMP_UP_PERIOD_FLAG);
            this.setActiveInitialDiscountPeriodFlag(raw.ACTIVE_INITIAL_DISCOUNT_PERIOD_FLAG);
        }
    }

    public getPayerCountry(): string {
        return this.payerCountry;
    }

    public setPayerCountry(payerCountry: string): void {
        this.payerCountry = payerCountry;
    }

    public getCurrencyCode(): string {
        return this.currencyCode;
    }

    public setCurrencyCode(currencyCode: string): void {
        this.currencyCode = currencyCode;
    }

    public getCpaKey(): string {
        return this.cpaKey;
    }

    public setCpaKey(cpaKey: string): void {
        this.cpaKey = cpaKey;
    }

    public getCpaName(): string | null {
        return this.cpaName;
    }

    public setCpaName(cpaName: string | null): void {
        this.cpaName = cpaName;
    }

    public getDiscountKey(): string {
        return this.discountKey;
    }

    public setDiscountKey(discountKey: string): void {
        this.discountKey = discountKey;
    }

    public getDiscountProductGroup(): string {
        return this.discountProductGroup;
    }

    public setDiscountProductGroup(discountProductGroup: string): void {
        this.discountProductGroup = discountProductGroup;
    }

    public getMarketedProductGroup(): string | null {
        return this.marketedProductGroup;
    }

    public setMarketedProductGroup(marketedProductGroup: string | null): void {
        this.marketedProductGroup = marketedProductGroup;
    }

    public getProductGroupOrder(): number | null {
        return this.productGroupOrder;
    }

    public setProductGroupOrder(productGroupOrder: number | null): void {
        this.productGroupOrder = productGroupOrder;
    }

    public getReviewDtm(): number | null {
        return this.reviewDtm;
    }

    public setReviewDtm(reviewDtm: number | null): void {
        this.reviewDtm = reviewDtm;
    }

    public getReportDtm(): number | null {
        return this.reportDtm;
    }

    public setReportDtm(reportDtm: number | null): void {
        this.reportDtm = reportDtm;
    }

    public getInitialDiscountPercent(): number | null {
        return this.initialDiscountPercent;
    }

    public setInitialDiscountPercent(initialDiscountPercent: number | null): void {
        this.initialDiscountPercent = initialDiscountPercent;
    }

    public getDiscountPercent(): number | null {
        return this.discountPercent;
    }

    public setDiscountPercent(discountPercent: number | null): void {
        this.discountPercent = discountPercent;
    }

    public getRevenueCount(): number | null {
        return this.revenueCount;
    }

    public setRevenueCount(revenueCount: number | null): void {
        this.revenueCount = revenueCount;
    }

    public getRampUpPeriod(): number | null {
        return this.rampUpPeriod;
    }

    public setRampUpPeriod(rampUpPeriod: number | null): void {
        this.rampUpPeriod = rampUpPeriod;
    }

    public getInitialDiscountPeriod(): number | null {
        return this.initialDiscountPeriod;
    }

    public setInitialDiscountPeriod(initialDiscountPeriod: number | null): void {
        this.initialDiscountPeriod = initialDiscountPeriod;
    }

    public getMeasurementPeriod(): number | null {
        return this.measurementPeriod;
    }

    public setMeasurementPeriod(measurementPeriod: number | null): void {
        this.measurementPeriod = measurementPeriod;
    }

    public getDiscountPeriod(): number | null {
        return this.discountPeriod;
    }

    public setDiscountPeriod(discountPeriod: number | null): void {
        this.discountPeriod = discountPeriod;
    }

    public getRampUpStartDate(): number | null {
        return this.rampUpStartDate;
    }

    public setRampUpStartDate(rampUpStartDate: number | null): void {
        this.rampUpStartDate = rampUpStartDate;
    }

    public getRampUpEndDate(): number | null {
        return this.rampUpEndDate;
    }

    public setRampUpEndDate(rampUpEndDate: number | null): void {
        this.rampUpEndDate = rampUpEndDate;
    }

    public getInitialDiscountStartDate(): number | null {
        return this.initialDiscountStartDate;
    }

    public setInitialDiscountStartDate(initialDiscountStartDate: number | null): void {
        this.initialDiscountStartDate = initialDiscountStartDate;
    }

    public getInitialDiscountEndDate(): number | null {
        return this.initialDiscountEndDate;
    }

    public setInitialDiscountEndDate(initialDiscountEndDate: number | null): void {
        this.initialDiscountEndDate = initialDiscountEndDate;
    }

    public getMeasurementStartDate(): number | null {
        return this.measurementStartDate;
    }

    public setMeasurementStartDate(measurementStartDate: number | null): void {
        this.measurementStartDate = measurementStartDate;
    }

    public getMeasurementEndDate(): number | null {
        return this.measurementEndDate;
    }

    public setMeasurementEndDate(measurementEndDate: number | null): void {
        this.measurementEndDate = measurementEndDate;
    }

    public getDiscountStartDate(): number | null {
        return this.discountStartDate;
    }

    public setDiscountStartDate(discountStartDate: number | null): void {
        this.discountStartDate = discountStartDate;
    }

    public getDiscountEndDate(): number | null {
        return this.discountEndDate;
    }

    public setDiscountEndDate(discountEndDate: number | null): void {
        this.discountEndDate = discountEndDate;
    }

    public getNextMeasurementPeriod(): number | null {
        return this.nextMeasurementPeriod;
    }

    public setNextMeasurementPeriod(nextMeasurementPeriod: number | null): void {
        this.nextMeasurementPeriod = nextMeasurementPeriod;
    }

    public getNextMeasurementMonths(): number | null {
        return this.nextMeasurementMonths;
    }

    public setNextMeasurementMonths(nextMeasurementMonths: number | null): void {
        this.nextMeasurementMonths = nextMeasurementMonths;
    }

    public getNextDiscountPeriod(): number | null {
        return this.nextDiscountPeriod;
    }

    public setNextDiscountPeriod(nextDiscountPeriod: number | null): void {
        this.nextDiscountPeriod = nextDiscountPeriod;
    }

    public getNextMeasurementStartDateOffset(): number | null {
        return this.nextMeasurementStartDateOffset;
    }

    public setNextMeasurementStartDateOffset(nextMeasurementStartDateOffset: number | null): void {
        this.nextMeasurementStartDateOffset = nextMeasurementStartDateOffset;
    }

    public getNextMeasurementStartDate(): number | null {
        return this.nextMeasurementStartDate;
    }

    public setNextMeasurementStartDate(nextMeasurementStartDate: number | null): void {
        this.nextMeasurementStartDate = nextMeasurementStartDate;
    }

    public getNextMeasurementEndDate(): number | null {
        return this.nextMeasurementEndDate;
    }

    public setNextMeasurementEndDate(nextMeasurementEndDate: number | null): void {
        this.nextMeasurementEndDate = nextMeasurementEndDate;
    }

    public getNextDiscountStartDate(): number | null {
        return this.nextDiscountStartDate;
    }

    public setNextDiscountStartDate(nextDiscountStartDate: number | null): void {
        this.nextDiscountStartDate = nextDiscountStartDate;
    }

    public getNextDiscountEndDate(): number | null {
        return this.nextDiscountEndDate;
    }

    public setNextDiscountEndDate(nextDiscountEndDate: number | null): void {
        this.nextDiscountEndDate = nextDiscountEndDate;
    }

    public getThresholdType(): string | null {
        return this.thresholdType;
    }

    public setThresholdType(thresholdType: string | null): void {
        this.thresholdType = thresholdType;
    }

    public getDiscountTiersAndValues(): string | null {
        return this.discountTiersAndValues;
    }

    public setDiscountTiersAndValues(discountTiersAndValues: string | null): void {
        this.discountTiersAndValues = discountTiersAndValues;
    }

    public getShipmentProgressCount(): number | null {
        return this.shipmentProgressCount;
    }

    public setShipmentProgressCount(shipmentProgressCount: number | null): void {
        this.shipmentProgressCount = shipmentProgressCount;
    }

    public getRevenueProgressCount(): number | null {
        return this.revenueProgressCount;
    }

    public setRevenueProgressCount(revenueProgressCount: number | null): void {
        this.revenueProgressCount = revenueProgressCount;
    }

    public getShipmentGapToCurrentLevel(): number | null {
        return this.shipmentGapToCurrentLevel;
    }

    public setShipmentGapToCurrentLevel(shipmentGapToCurrentLevel: number | null): void {
        this.shipmentGapToCurrentLevel = shipmentGapToCurrentLevel;
    }

    public getRevenueGapToCurrentLevel(): number | null {
        return this.revenueGapToCurrentLevel;
    }

    public setRevenueGapToCurrentLevel(revenueGapToCurrentLevel: number | null): void {
        this.revenueGapToCurrentLevel = revenueGapToCurrentLevel;
    }

    public getShipmentGapToNextLevel(): number | null {
        return this.shipmentGapToNextLevel;
    }

    public setShipmentGapToNextLevel(shipmentGapToNextLevel: number | null): void {
        this.shipmentGapToNextLevel = shipmentGapToNextLevel;
    }

    public getRevenueGapToNextLevel(): number | null {
        return this.revenueGapToNextLevel;
    }

    public setRevenueGapToNextLevel(revenueGapToNextLevel: number | null): void {
        this.revenueGapToNextLevel = revenueGapToNextLevel;
    }

    public getReviewFlag(): string | null {
        return this.reviewFlag;
    }

    public setReviewFlag(reviewFlag: string | null): void {
        this.reviewFlag = reviewFlag;
    }

    public getActiveRampUpPeriodFlag(): string | null {
        return 'N';
        // return this.activeRampUpPeriodFlag;
    }

    public setActiveRampUpPeriodFlag(activeRampUpPeriodFlag: string | null): void {
        this.activeRampUpPeriodFlag = activeRampUpPeriodFlag;
    }

    public getActiveInitialDiscountPeriodFlag(): string | null {
        return 'N';
        // return this.activeInitialDiscountPeriodFlag;
    }

    public setActiveInitialDiscountPeriodFlag(activeInitialDiscountPeriodFlag: string | null): void {
        this.activeInitialDiscountPeriodFlag = activeInitialDiscountPeriodFlag;
    }

}